import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';
import styles from 'sections/Resources/FreightTemplates/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>
      <div className={cn('container')}>

        <div className={cn('header__heading-container')}>

          <h1 className={cn('header__heading')}>
            <span>Free Shipping Document Templates</span>
          </h1>

          <div className={cn('header__description')}>
            <p className={cn('header__paragraph')}>
              Streamline your logistics operations with DF Alliance’s
              free freight document templates.
            </p>
            <p className={cn('header__paragraph')}>
              Whether you're managing shipments, preparing customs paperwork,
              or quoting clients, our professionally designed templates — including
              invoices, packing lists, proforma invoices, and bills of lading — help
              you save time and reduce errors.
            </p>
            <p className={cn('header__paragraph')}>
              These resources are tailored for freight forwarders, logistics providers,
              and exporters looking for reliable documentation tools that meet
              international standards. Download and customize each template to
              fit your workflow and stay compliant across borders.
            </p>
          </div>

          <div className={cn('header__buttons')}>
            {/* TODO: set href to documents section */}
            <Link
              className={cn('header__button-choose')}
              href='#templates'
            >
              Choose Template
            </Link>
          </div>

        </div>

      </div>
    </section>
  );
};

export default SectionHeader;